import { StyleSheet } from 'react-native';

import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default StyleSheet.create({
    button: {
        width: 172,
        minHeight: 44,
        backgroundColor: Colors.white,
        paddingHorizontal: Layout.gutterSmall,
        paddingVertical: Layout.gutterSmall,
        flexDirection: 'row',
        borderRadius: 6,
        borderWidth: 1,
        borderColor: Colors.border
    },
    buttonBox: {
        flex: 1,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    buttonText: {
        fontSize: 18,
        color: Colors.black,
        paddingHorizontal: Layout.gutterMin
    },
    buttonDisabled: {
        backgroundColor: Colors.regular
    },
    text: {
        justifyContent: 'flex-start'
    },
    icon: {
        justifyContent: 'flex-end'
    }
});
